export const EMOTION_CACHE_KEY = "cars";
